import { contentGet, contentPost, contentPut } from '../../../../shared/email-activity/content-api'
import { authGet } from '../../../../shared/sso-workspace/auth-api'
import { viewerTimeZone } from '../../../../shared/date/local-time'

// Content's /api/ddd/errors routes (error groups and their samples), and
// auth's alert-routing runs filtered to one group.
export const listGroups = params => contentGet('errors/groups', params)
export const getFacets = () => contentGet('errors/facets')
export const getGroup = id => contentGet(`errors/groups/${id}`)
export const getOccurrences = (id, params) => contentGet(`errors/groups/${id}/occurrences`, params)
// buckets: the reader's hours and days (tz=, owner 2026-10-08), answered as instants
export const getBuckets = (id, params) => contentGet(`errors/groups/${id}/buckets`, { ...(params || {}), tz: viewerTimeZone() })
export const getBreakdown = id => contentGet(`errors/groups/${id}/from`)
export const setStatus = (id, action) => contentPost(`errors/groups/${id}/${action}`, {})
// selected: { ids } (1-200), or "all matching" { filter, except? } (the
// list's filters with upTo, when it was chosen; at most 1,000 change, more
// is 413 errors.too_many_matches and nothing changes).
export const bulkAction = (selected, action) => contentPost('errors/groups/bulk', { ...selected, action })
export const setLinks = (id, links) => contentPut(`errors/groups/${id}/links`, { links })
export const setNote = (id, note) => contentPut(`errors/groups/${id}/note`, { note })
export const listGroupAlerts = id => authGet('alert-routing/runs', { subjectRef: `error_group:${id}`, limit: 20 })
